"use client";

import * as React from 'react';
const ModalContext = /*#__PURE__*/React.createContext({
  onHide() {}
});
export default ModalContext;